/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiLink } from '@elastic/eui'

import type { AnyAdminProject } from '@modules/project-admin-api/types'

// eslint-disable-next-line import/no-restricted-paths
import { getConfigForKey } from '@/store'

const DASHBOARDS = {
  'serverless-project-id-overview': (
    <FormattedMessage
      id='project.link.serverless-project-id-overview'
      defaultMessage='Project overview'
    />
  ),
  'serverless-project-applications-logs': (
    <FormattedMessage
      id='project.link.serverless-project-applications-logs'
      defaultMessage='Project application logs'
    />
  ),
  'serverless-control-plane-services-logs': (
    <FormattedMessage
      id='project.link.serverless-control-plane-services-logs'
      defaultMessage='Control Plane services logs'
    />
  ),
  'serverless-es-project-stack-monitoring': (
    <FormattedMessage
      id='project.link.serverless-es-project-stack-monitoring'
      defaultMessage='Elasticsearch project stack monitoring'
    />
  ),
  'serverless-es-project-overview': (
    <FormattedMessage
      id='project.link.serverless-es-project-overview'
      defaultMessage='Elasticsearch project overview'
    />
  ),
}

export type Props = {
  project: AnyAdminProject
  dashboard: keyof typeof DASHBOARDS
}

const ObservabilityDashboardLink: React.FunctionComponent<Props> = ({ project, dashboard }) => {
  const o11yDomain = getConfigForKey(`CLOUD_SERVERLESS_O11Y_DOMAIN`)

  if (!o11yDomain) {
    return null
  }

  const url = `https://${o11yDomain}/app/dashboards#/view/${dashboard}?_g=(filters:!((query:(match_phrase:(serverless.project.id:${project.id})))))`

  return (
    <EuiLink external={true} href={url} target='_blank'>
      {DASHBOARDS[dashboard]}
    </EuiLink>
  )
}

export default ObservabilityDashboardLink
